import React, { useState, useEffect } from "react";

const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const EmiSchedule = ({
    loanAmount = 1000000,
    rate = 6.5,
    tenure = 20, // years
}) => {
    const [schedule, setSchedule] = useState([]);
    const [openYear, setOpenYear] = useState(null);

    useEffect(() => {
        generateSchedule();
    }, [loanAmount, rate, tenure]);

    const generateSchedule = () => {
        // Validation to prevent infinite loops or errors
        if (!loanAmount || !rate || !tenure) return;

        const r = rate / 12 / 100; // monthly interest
        const n = Math.round(tenure * 12); // total months

        // EMI Formula
        const emi = (loanAmount * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);

        let balance = loanAmount;
        let scheduleMap = {};
        const today = new Date();
        let currentMonthIndex = today.getMonth();
        let currentYear = today.getFullYear();

        for (let i = 0; i < n; i++) {
            const interest = balance * r;
            const principal = emi - interest;
            balance -= principal;

            const monthName = monthNames[currentMonthIndex];

            if (!scheduleMap[currentYear]) scheduleMap[currentYear] = [];

            scheduleMap[currentYear].push({
                month: monthName,
                principal: Math.round(principal),
                interest: Math.round(interest),
                emi: Math.round(emi),
                balance: Math.round(balance > 0 ? balance : 0),
            });

            currentMonthIndex++;
            if (currentMonthIndex > 11) {
                currentMonthIndex = 0;
                currentYear++;
            }
        }

        const scheduleArray = Object.keys(scheduleMap).map((year) => ({
            year,
            months: scheduleMap[year],
        }));

        setSchedule(scheduleArray);
    };

    return (
        <div className="emi-schedule-section">
            <h2 className="schedule-title">EMI Payment Schedule</h2>

            {schedule.map((yearItem) => (
                <div key={yearItem.year} className="year-card">
                    <div
                        className="year-header"
                        onClick={() =>
                            setOpenYear(openYear === yearItem.year ? null : yearItem.year)
                        }
                    >
                        <div>
                            <strong>Year {yearItem.year}</strong>
                            <p>{yearItem.months.length} Payments</p>
                        </div>

                        <span className="toggle-text">
                            {openYear === yearItem.year
                                ? "Hide Monthly Breakup ▲"
                                : "Show Monthly Breakup ▼"}
                        </span>
                    </div>

                    {openYear === yearItem.year && (
                        <div className="table-wrapper">
                            <table className="emi-table">
                                <thead>
                                    <tr>
                                        <th>Month</th>
                                        <th>Principal</th>
                                        <th>Interest</th>
                                        <th>Total (EMI)</th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {yearItem.months.map((m, index) => (
                                        <tr key={index}>
                                            <td>{m.month}</td>
                                            <td>₹{m.principal.toLocaleString('en-IN')}</td>
                                            <td>₹{m.interest.toLocaleString('en-IN')}</td>
                                            <td>₹{m.emi.toLocaleString('en-IN')}</td>
                                            <td>₹{m.balance.toLocaleString('en-IN')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default EmiSchedule;